import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTheme } from "../../contexts/ThemeContext";
import { AccountsFilter } from "./model/AccountsFilter";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { useLocalization } from "../../contexts/LocalizationContext";
import { AccountsFilterActionType } from "./model/AccountsFilterActionType";
import { FilterTagsBuilder } from "./model/FilterTagsBuilder";
import { Button } from "react-bootstrap";

type AppliedFiltersProps = {
  filters: AccountsFilter;
  handleFiltersChange: (action: AccountsFilterActionType, value?: string) => void;
};

export const AppliedFilters = ({ filters, handleFiltersChange }: AppliedFiltersProps) => {
  const { buttonStyle } = useTheme();
  const { translate } = useLocalization();
  const tags = new FilterTagsBuilder(filters).getAll(translate);

  return (
    <div className="d-flex flex-wrap">
      {tags.some((x) => x.value !== "") && (
        <Button
          style={buttonStyle}
          className="me-2 py-0 text-white"
          onClick={() => handleFiltersChange(AccountsFilterActionType.ClearAll)}
        >
          <FontAwesomeIcon className="me-2" icon={faTimesCircle} />
          {translate("common.clearAllFilters")}
        </Button>
      )}
      {tags
        .filter((x) => x.value !== "")
        .map((x, i) => (
          <Button
            key={i}
            style={buttonStyle}
            className="me-2 py-0 text-white"
            onClick={() => handleFiltersChange(x.action, x.value)}
          >
            <FontAwesomeIcon className="me-2" icon={faTimesCircle} />
            <span aria-label={translate("common.removeFilter")} />
            {`${x.type}: ${x.value}`}
          </Button>
        ))}
    </div>
  );
};
